import { render } from "./StatsTarget.vue?vue&type=template&id=469abf2e&scoped=true"
import script from "./StatsTarget.vue?vue&type=script&lang=js"
export * from "./StatsTarget.vue?vue&type=script&lang=js"

import "./StatsTarget.vue?vue&type=style&index=0&id=469abf2e&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469abf2e"]])

export default __exports__